import type { LoaderFunctionArgs } from "react-router";
import { redirect, Form, useLoaderData } from "react-router";

import { login } from "../../shopify.server";
import { organizationConfig } from "../../config/organization";

import styles from "./styles.module.css";

export const loader = async ({ request }: LoaderFunctionArgs) => {
  const url = new URL(request.url);

  if (url.searchParams.get("shop")) {
    throw redirect(`/app?${url.searchParams.toString()}`);
  }

  return { showForm: Boolean(login) };
};

export default function App() {
  const { showForm } = useLoaderData<typeof loader>();

  return (
    <div className={styles.index}>
      <div className={styles.content}>
        <h1 className={styles.heading}>Welcome to {organizationConfig.brandName}</h1>
        {showForm && (
          <Form className={styles.form} method="post" action="/auth/login">
            <label className={styles.label}>
              <span className={styles.labelText}>Shop Domain</span>
              <input
                className={styles.input}
                type="text"
                name="shop"
                placeholder="your-shop.myshopify.com"
                required
              />
            </label>
            <button className={styles.button} type="submit">
              Continue
            </button>
          </Form>
        )}
      </div>
    </div>
  );
}
